export const aboutContent = {
  intro: {
    title: '关于男同网',
    subtitle: '构建温暖、包容、真实的男同社区',
    description: '男同网成立于2020年，是专为中文男同群体打造的综合性平台。我们致力于为男同朋友提供交友认识、社群互动、生活资讯、健康指南及活动资讯等全方位服务。',
    mission: '我们的使命是帮助每一位男同朋友找到志同道合的伙伴，探索真实的自我，在一个温暖包容的社区中获得归属感与成长力量。',
    vision: '我们相信，每一个人都值得被看见、被理解、被接纳。男同网的愿景是成为中国最具温度和影响力的男同社区平台，让每一位用户都能在这里找到属于自己的位置。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20and%20inclusive%20community%20gathering%20space%20with%20diverse%20group%20of%20people%20connecting%2C%20soft%20natural%20lighting%2C%20modern%20cozy%20interior%2C%20plants%20and%20art%20on%20walls%2C%20feeling%20of%20belonging%20and%20acceptance%2C%20coral%20and%20golden%20warm%20tones&width=1200&height=600&seq=about-brand-hero&orientation=landscape',
  },
  timeline: [
    { year: '2020', title: '平台创立', description: '男同网正式上线，以资讯分享为核心，服务第一批用户。' },
    { year: '2021', title: '社群功能上线', description: '推出社群互动功能，用户可以在平台上交流讨论、分享生活。' },
    { year: '2022', title: '用户突破10万', description: '凭借优质内容和良好的社区氛围，注册用户突破10万人。' },
    { year: '2023', title: '健康频道开通', description: '联合专业医疗机构，推出健康指南频道，提供科学的健康资讯。' },
    { year: '2024', title: '活动平台启动', description: '开通活动资讯频道，成为全国男同活动信息的重要发布平台。' },
    { year: '2025', title: '用户突破50万', description: '社区持续壮大，月活跃用户超过50万，成为领先的男同社区平台。' },
    { year: '2026', title: '全新升级', description: '平台全面升级，优化用户体验，推出更多个性化服务功能。' },
  ],
  testimonials: [
    {
      id: 1,
      name: '小杰',
      age: 28,
      city: '上海',
      content: '在男同网认识了我的男朋友，现在已经在一起两年了。感谢这个平台让我们相遇。这里不仅有交友功能，各种生活资讯也给了我很多帮助。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20with%20genuine%20happy%20smile%2C%20casual%20style%2C%20warm%20outdoor%20portrait%2C%20soft%20natural%20light%2C%20friendly%20and%20approachable&width=120&height=120&seq=testimonial-1&orientation=squarish',
    },
    {
      id: 2,
      name: '阿文',
      age: 35,
      city: '北京',
      content: '作为一个在职场打拼的男同，男同网的健康指南和心理成长文章给了我很多实用的建议和支持。特别是关于职场发展的内容，非常接地气。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20in%20his%2030s%20with%20confident%20smile%2C%20business%20casual%20attire%2C%20city%20background%2C%20warm%20studio%20portrait&width=120&height=120&seq=testimonial-2&orientation=squarish',
    },
    {
      id: 3,
      name: '老张',
      age: 48,
      city: '成都',
      content: '作为一个中年男同，曾经以为这个圈子已经不属于我了。但男同网让我重新找到了归属感，在这里我认识了很多同龄的朋友，生活变得丰富多彩。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20with%20warm%20kind%20smile%2C%20silver%20hair%2C%20relaxed%20casual%20style%2C%20outdoor%20park%20setting%2C%20gentle%20natural%20light&width=120&height=120&seq=testimonial-3&orientation=squarish',
    },
    {
      id: 4,
      name: 'Leo',
      age: 22,
      city: '广州',
      content: '刚上大学时对自己的性取向很迷茫，是男同网上的心理成长文章帮我走出了困境。现在我也经常参加线下活动，生活状态越来越好了。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Asian%20college%20student%20with%20bright%20optimistic%20smile%2C%20modern%20casual%20style%2C%20campus%20background%2C%20fresh%20youthful%20portrait&width=120&height=120&seq=testimonial-4&orientation=squarish',
    },
  ],
  stats: [
    { value: '500,000+', label: '注册用户' },
    { value: '1,200+', label: '优质文章' },
    { value: '300+', label: '线下活动' },
    { value: '98%', label: '用户满意度' },
  ],
  contact: {
    title: '联系我们',
    description: '如果你有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们会在24小时内回复你的消息。',
    email: 'contact@nantong.wang',
    wechat: 'nantongwang',
    address: '中国上海市',
  },
  faqs: [
    {
      question: '男同网是免费的吗？',
      answer: '是的，男同网的基础服务完全免费。你可以免费浏览文章、参与社群讨论、查看活动资讯。我们致力于让每一位男同朋友都能无障碍地获取有价值的资讯和温暖的社群支持。',
    },
    {
      question: '如何保护用户的隐私安全？',
      answer: '我们非常重视用户隐私保护。你的个人信息采用加密存储，你可以自由选择公开或隐藏个人资料。我们绝不会在未经你同意的情况下向第三方披露你的个人信息。',
    },
    {
      question: '如何参与线下活动？',
      answer: '你可以在"活动资讯"频道查看全国各地的最新活动信息。每场活动都有详细的报名方式和参与须知。建议关注你所在城市的男同社群公众号，获取第一手活动资讯。',
    },
    {
      question: '我想投稿文章，应该如何操作？',
      answer: '我们非常欢迎社群成员分享自己的故事和见解。你可以通过联系表单或发送邮件至 contact@nantong.wang 提交你的稿件。我们的编辑团队会在3个工作日内审核并回复。',
    },
    {
      question: '平台上的健康资讯可靠吗？',
      answer: '我们的健康指南内容均经过专业医疗人员审核，确保信息的科学性和准确性。但请注意，平台内容仅供参考，不能替代专业医疗诊断。如有健康问题，请及时就医。',
    },
  ],
};